import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FormInputType } from "services/models/form-builder/enum/form-input-type.enum";
import { FormItemOptionModel } from "services/models/form-builder/form-item-option.model";
import { FormItemModel } from "services/models/form-builder/form-item.model";

@Component({
  selector: "app-form-input-radio",
  template: `
    <div
      class="flex mt-0 field-space"
      [ngClass]="
        isNumericScale
          ? 'flex-row align-items-center numeric-scale-options'
          : 'flex-column gap-4'
      "
    >
      <ng-container
        *ngFor="let option of getOrderedOptions(item.options); let j = index"
      >
        <div
          class="custom-control custom-radio"
          [ngClass]="{ 'numeric-scale-option': isNumericScale }"
        >
          <input
            type="radio"
            [id]="'option' + i + '-' + j"
            class="custom-control-input layout-name"
            [name]="'item-' + i"
            [disabled]="readonly"
            [value]="option.label || option"
            [checked]="control.value === (option.label || option)"
            (change)="control.setValue(option.label || option)"
          />
          <label
            class="custom-control-label question-item-label"
            [for]="'option' + i + '-' + j"
            [ngbTooltip]="option.legend"
          >
            {{ option.label || option }}

            <ng-container *ngIf="getTrueOrFalseGlyph(option) as glyph; else optionIcon">
              <span
                *ngIf="glyph"
                class="badge badge-pill ml-50"
                [ngClass]="getTrueOrFalseBadgeClass(option)"
              >
                {{ glyph }}
              </span>
            </ng-container>
            <ng-template #optionIcon>
              <i *ngIf="option.iconName" class="feather icon-{{ option.iconName }} ml-50"></i>
            </ng-template>
          </label>
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .numeric-scale-options {
        gap: 0.75rem;
        flex-wrap: wrap;
      }

      .numeric-scale-option {
        margin-bottom: 0;
      }

      .numeric-scale-option .custom-control-label {
        white-space: nowrap;
      }
    `,
  ],
})
export class FormInputRadioComponent {
  @Input() item!: FormItemModel;
  @Input() control!: FormControl;
  @Input() i!: number;
  @Input() readonly: boolean = false;

  get isNumericScale(): boolean {
    return this.item?.inputType === FormInputType.NUMERIC_SCALE.value;
  }

  getTrueOrFalseGlyph(option: FormItemOptionModel): string {
    if (this.item?.inputType !== FormInputType.TRUE_OR_FALSE.value) return '';
    if ((option?.order || 0) === 1) return '✓';
    if ((option?.order || 0) === 2) return '✗';
    return '';
  }

  getTrueOrFalseBadgeClass(option: FormItemOptionModel): string {
    const order = option?.order || 0;
    if (this.item?.inputType !== FormInputType.TRUE_OR_FALSE.value) return '';
    if (order === 1) return 'badge-light-success text-success';
    if (order === 2) return 'badge-light-danger text-danger';
    return '';
  }

  getOrderedOptions(options?: FormItemOptionModel[]): FormItemOptionModel[] {
    if (!options) return [];
    return options.slice().sort((a, b) => (a.order || 0) - (b.order || 0));
  }
}
